import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TASK_CATEGORY } from "../apiRoutes";

const mutateUpdateTaskCategory = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${TASK_CATEGORY}${id}`, data);
};

const useUpdateTaskCategorysMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateTaskCategory,
    ...queryParams,
  });

export default useUpdateTaskCategorysMutation;
